import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Textarea } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Copy, Check } from 'lucide-react';
export function EmailExtractor() {
  const [inputText, setInputText] = useState('');
  const [emails, setEmails] = useState<string[]>([]);
  const [copied, setCopied] = useState(false);
  const extractEmails = () => {
    const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const found = inputText.match(emailRegex) || [];
    const unique = Array.from(new Set(found));
    setEmails(unique);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(emails.join('\n'));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="container mx-auto px-4 py-8 max-w-4xl" data-id="element-669">
      <div className="mb-8" data-id="element-670">
        <h1 className="text-4xl font-bold mb-2" data-id="element-671">Email Extractor</h1>
        <p className="text-muted-foreground" data-id="element-672">
          Extract all email addresses from text
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-673">
        <Card data-id="element-674">
          <CardHeader data-id="element-675">
            <CardTitle data-id="element-676">Input Text</CardTitle>
            <CardDescription data-id="element-677">
              Paste text containing email addresses
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-678">
            <Textarea value={inputText} onChange={e => setInputText(e.target.value)} placeholder="Paste your text here... Emails like john@example.com will be extracted." rows={12} data-id="element-679" />
            <Button onClick={extractEmails} className="w-full" data-id="element-680">
              Extract Emails
            </Button>
          </CardContent>
        </Card>

        <Card data-id="element-681">
          <CardHeader data-id="element-682">
            <div className="flex items-center justify-between" data-id="element-683">
              <div data-id="element-684">
                <CardTitle data-id="element-685">Extracted Emails</CardTitle>
                <CardDescription data-id="element-686">
                  {emails.length} email{emails.length !== 1 ? 's' : ''} found
                </CardDescription>
              </div>
              {emails.length > 0 && <Button onClick={copyToClipboard} variant="outline" size="sm" data-id="element-687">
                  {copied ? <Check className="w-4 h-4 mr-2" data-id="element-688" /> : <Copy className="w-4 h-4 mr-2" data-id="element-689" />}
                  {copied ? 'Copied!' : 'Copy All'}
                </Button>}
            </div>
          </CardHeader>
          <CardContent data-id="element-690">
            {emails.length > 0 ? <div className="space-y-2" data-id="element-691">
                {emails.map((email, index) => <div key={index} className="p-3 bg-muted rounded-lg font-mono text-sm break-all" data-id="element-692">
                    {email}
                  </div>)}
              </div> : <div className="text-center py-12 text-muted-foreground" data-id="element-693">
                No emails extracted yet. Paste text and click "Extract Emails".
              </div>}
          </CardContent>
        </Card>
      </div>
    </div>;
}